import React from 'react';

import Body from '../typography/Body';
import Caption from '../typography/Caption';
import Headline from '../typography/Headline';
import Subtitle from '../typography/Subtitle';
import Title from '../typography/Title';

import StickersheetRow from './StickersheetRow';

export default () => (
  <StickersheetRow title="Typography">
    <div>
      <Title>Title</Title>
      <Subtitle>Subtitle</Subtitle>
      <Headline>Headline</Headline>
      <Body>Body</Body>
      <Caption>Caption</Caption>
    </div>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/Typography.js